<template>
  <div class="StatisticsTable">
    <template v-if="nowPage == '歷史參數查詢'"
      ><heatTreatmentInquire
    /></template>
    <template v-else-if="nowPage == '統計分析'"
      ><heatTreatmentAnalysis
    /></template>
    <template v-else-if="nowPage == '自主檢驗超時'"
      ><inspectTimeout
    /></template>
  </div>
</template>

<script>
import heatTreatmentInquire from "@/components/heatTreatmentInquire.vue";
import heatTreatmentAnalysis from "@/components/heatTreatmentAnalysis.vue";
import inspectTimeout from "@/components/inspectTimeout.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "StatisticsTable",
  data() {
    return {
      nowPage: ""
    };
  },
  created: function() {
    window.addEventListener("beforeunload", this.setSessionItems);
    let page = sessionStorage.getItem("statistics_table_page");
    if (page == "歷史參數查詢") {
      this.set_sideBarSelect(["statisticstable", "heattreatmentinquire"]);
    } else if (page == "統計分析") {
      this.set_sideBarSelect(["statisticstable", "heattreatmentanalysis"]);
    } else if (page == "自主檢驗超時") {
      this.set_sideBarSelect(["statisticstable", "inspecttimeout"]);
    }

    sessionStorage.removeItem("statistics_table_page");
    this.change_selectPage("statisticstable");
    this.change_selectPageName(this.pageName.statisticstable);
  },
  mounted: function() {
    let vm = this;
    vm.nowPage = vm.sideBarSelect.processName;
    console.log(vm.nowPage);
  },
  components: {
    heatTreatmentInquire,
    heatTreatmentAnalysis,
    inspectTimeout
  },
  watch: {
    sideBarSelect: {
      handler() {
        let vm = this;
        vm.nowPage = vm.sideBarSelect.processName;
      }
    }
  },
  computed: {
    ...mapGetters({
      pageName: "getlogin/get_pageName",
      sideBarSelect: "sideBarTree/get_sideBarSelect"
    })
  },
  methods: {
    ...mapActions({
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_sideBarSelect: "sideBarTree/set_sideBarSelect"
    }),
    setSessionItems() {
      sessionStorage.setItem(
        "statistics_table_page",
        this.sideBarSelect.processName
      );
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.setSessionItems);
  }
};
</script>

<style scoped></style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/StatisticsTable.vue